module.exports = __webpack_public_path__ + "5b057a227c11cb0c43e7502d7c3933b6.otf";